<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing']"
        >
          Keywords
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Off-P Prospects </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div>

  <div class="row mb-3 mt-1">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filter()"
          list="suggestionsProspects"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent">
          <i class="fas fa-search text-dark"></i>
        </span>
        <datalist id="suggestionsProspects">
          <option
            *ngFor="let suggestion of searchSuggestions"
            [value]="suggestion"
          ></option>
        </datalist>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12">
      <a
        class="btn btn-dark btn-sm btn-new-sm"
        [routerLink]="['/marketing/seo/offPageProspects/add']"
      >
        NEW
      </a>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Prospect</th>
              <th>Domain</th>
              <th>Type</th>
              <th>City</th>
              <th>Relevance</th>
              <th>Authority</th>
              <th>Outreach</th>
              <th>Execution</th>
              <th>Status</th>
              <th>Sugg Anchor</th>
              <th>FollowUp</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="title-cell"
                (click)="showModal('Prospect', item.prospectName)"
                title="Click to view full URL"
              >
                {{ item.prospectName }}
              </td>
              <td>
                <a
                  [href]="'https://' + item.domain"
                  target="_blank"
                  class="text-info"
                >
                  {{ item.domain }}
                </a>
              </td>
              <td>{{ item.prospectType }}</td>
              <td class="city-cell">{{ item.city }}</td>
              <td>{{ item.relevanceScore }}</td>
              <td>{{ item.authorityScore }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="getStatusBadgeClass(item.outreachStatus)"
                >
                  {{ item.outreachStatus | uppercase }}
                </span>
              </td>
              <td>
                <span
                  class="badge px-2 py-1"
                  [ngClass]="getExecutionTypeBadgeClass(item.executionType)"
                >
                  {{ item.executionType | uppercase }}
                </span>
              </td>
              <td>
                <span
                  class="badge px-2 py-1"
                  [ngClass]="getExecutionStatusBadgeClass(item.executionStatus)"
                >
                  {{ item.executionStatus | uppercase }}
                </span>
              </td>
              <td
                class="title-cell"
                (click)="showModal('Suggested Anchor', item.suggestedAnchor)"
                title="Click to view"
              >
                {{ item.suggestedAnchor }}
              </td>
              <td>{{ item.followUpAt | date: "shortDate" }}</td>
              <td class="text-nowrap">
                <a
                  class="btn btn-link text-info btn-sm"
                  [routerLink]="[
                    '/marketing/seo/offPageProspects/view',
                    item._id,
                  ]"
                  title="View"
                >
                  <i class="fas fa-eye"></i>
                </a>
                <a
                  class="btn btn-link text-dark btn-sm"
                  [routerLink]="[
                    '/marketing/seo/offPageProspects/edit',
                    item._id,
                  ]"
                  title="Edit"
                >
                  <i class="fas fa-pen"></i>
                </a>

                <!-- Conditionally Rendered Execution Buttons -->

                <!-- A. If executionType = self_serve -->
                <ng-container *ngIf="item.executionType === 'self_serve'">
                  <button
                    *ngIf="item.executionStatus === 'pending'"
                    class="btn btn-link text-primary btn-sm"
                    (click)="markReady(item)"
                    title="Preparar registro"
                  >
                    <i class="fas fa-file-signature"></i>
                  </button>
                  <button
                    *ngIf="
                      item.executionStatus === 'ready' ||
                      item.executionStatus === 'researching'
                    "
                    class="btn btn-link text-info btn-sm"
                    (click)="markSubmitted(item)"
                    title="Marcar enviado"
                  >
                    <i class="fas fa-paper-plane"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'submitted'"
                    class="btn btn-link text-success btn-sm"
                    (click)="markPublishedExecution(item)"
                    title="Marcar publicado"
                  >
                    <i class="fas fa-check-circle"></i>
                  </button>
                </ng-container>

                <!-- B. If executionType = claim -->
                <ng-container *ngIf="item.executionType === 'claim'">
                  <button
                    *ngIf="item.executionStatus === 'pending'"
                    class="btn btn-link text-warning btn-sm"
                    (click)="markResearching(item)"
                    title="Revisar ficha"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'researching'"
                    class="btn btn-link text-info btn-sm"
                    (click)="markSubmitted(item)"
                    title="Marcar reclamado"
                  >
                    <i class="fas fa-hand-holding-heart"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'submitted'"
                    class="btn btn-link text-secondary btn-sm"
                    (click)="markVerificationPending(item)"
                    title="Verificación pendiente"
                  >
                    <i class="fas fa-hourglass-half"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'verification_pending'"
                    class="btn btn-link text-success btn-sm"
                    (click)="markPublishedExecution(item)"
                    title="Marcar publicado"
                  >
                    <i class="fas fa-check-circle"></i>
                  </button>
                </ng-container>

                <!-- C. If executionType = outreach -->
                <ng-container *ngIf="item.executionType === 'outreach'">
                  <button
                    *ngIf="item.executionStatus === 'pending'"
                    class="btn btn-link text-dark btn-sm"
                    (click)="markReady(item)"
                    title="Preparar outreach"
                  >
                    <i class="fas fa-bullhorn"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'ready'"
                    class="btn btn-link text-primary btn-sm"
                    (click)="markContactedExecution(item)"
                    title="Contactar"
                  >
                    <i class="fas fa-envelope-open-text"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'contacted'"
                    class="btn btn-link text-info btn-sm"
                    (click)="markReplied(item)"
                    title="Marcar respuesta"
                  >
                    <i class="fas fa-reply"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'replied'"
                    class="btn btn-link text-warning btn-sm"
                    (click)="markApprovedExecution(item)"
                    title="Aprobar"
                  >
                    <i class="fas fa-thumbs-up"></i>
                  </button>
                  <button
                    *ngIf="item.executionStatus === 'approved'"
                    class="btn btn-link text-success btn-sm"
                    (click)="markPublishedExecution(item)"
                    title="Marcar publicado"
                  >
                    <i class="fas fa-check-circle"></i>
                  </button>
                </ng-container>

                <!-- D. If executionType = unknown -->
                <button
                  *ngIf="item.executionType === 'unknown'"
                  class="btn btn-link text-secondary btn-sm"
                  (click)="openReviewModal(item)"
                  title="Revisar"
                >
                  <i class="fas fa-question-circle"></i>
                </button>

                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-danger btn-sm"
                  title="Delete"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
